import { UnderlinedButton } from "@JohnLewisPartnership/jl-design-system/dist/components/button/Button";
import { Link } from "../../../types/prodcatBaseTypes";
import { dispatchAnalyticsEvent } from "../../../utils";
import styles from "./DescriptionLinks.module.scss";

type Props = {
  links: Link[];
};

export const DescriptionLinks = ({ links }: Props) => {
  if (links.length === 0) return null;

  const handleClick = () =>
    dispatchAnalyticsEvent(
      "global.interaction",
      {
        type: "pdp",
        subType: "product description accordion - buying guide",
      },
      { additionalInfo: {}, properties: {}, products: [] },
    );

  return (
    <ul data-testid="description:links" className={styles.container}>
      {links.map(({ linkUrl, text }) => (
        <li key={linkUrl}>
          <UnderlinedButton
            tag="a"
            data-testid="description:links:link"
            href={linkUrl}
            onClick={handleClick}
            labelText={text}
          />
        </li>
      ))}
    </ul>
  );
};
